// const BASE_URL = "http://localhost:5023/game2-api/";

// below with double endpoints is working one
const BASE_URL = "https://pluto2.passionit.com/game2-api/game2-api/"; 


//////////// Multiplayer APIs ////////////
// export const SOCKET_URL = "http://localhost:5023"; 
export const SOCKET_URL = "https://pluto2.passionit.com"; 

export const GET_ONLINE_PLAYERS_API = `${BASE_URL}get/online-players`; // Fetch online users
export const SEND_GAME_REQUEST_API = `${BASE_URL}post/send-game-request`; // Send game request
export const ACCEPT_GAME_REQUEST_API = `${BASE_URL}post/accept-game-request`; // Accept request
export const START_GAME_SESSION_API = `${BASE_URL}post/start-game-session`; // Start game session


export const LOGIN_API = `${BASE_URL}login`;
export const REGISTER_API = `${BASE_URL}register`;
export const GET_EMAIL_API = (email) => `${BASE_URL}get/regbyemail/${email}`;
export const PUT_REGISTER_API = (regid) => `${BASE_URL}reg/edit/${regid}`; 

///////////////////protectedroot///////////
export const GET_PROTECTED_API = `${BASE_URL}protected`;

/////////reset_forgot password//////////////
export const RESET_PASSWORD_API = `${BASE_URL}reset-password`
export const VALIDATE_TOKEN_API = `${BASE_URL}validate-reset-token`
export const UPDATE_PASSWORD_API = `${BASE_URL}password`
export const VERIFY_OTP_API = `${BASE_URL}verify-otp`

///////////////card group///////////////////
export const GET_CARDGROUP_API = `${BASE_URL}get/cardgroups`
export const POST_CARDGROUP_API = `${BASE_URL}post/cardgroups`
export const DELETE_CARDGROUP_API = (cardgrpid) => `${BASE_URL}delete/cardgroups/${cardgrpid}`; 
export const PUT_CARDGROUP_API = (cardgrpid) => `${BASE_URL}update/cardgroups/${cardgrpid}`; 
export const GET_CARDGROUP_BYID = (cardgrpid) => `${BASE_URL}get/cardgroups/${cardgrpid}`; 

////////////card/////////////////////
export const GET_CARD_API = `${BASE_URL}get/cards`
export const POST_CARD_API = `${BASE_URL}post/cards`
export const DELETE_CARD_API =(cardid)=> `${BASE_URL}delete/cards/${cardid}`
export const PUT_CARD_API = (cardid) => `${BASE_URL}update/cards/${cardid}`;
export const GET_CARD_BYID = (cardid) => `${BASE_URL}get/cards/${cardid}`;

////////////game category//////////////
export const GET_CATEGORY_API = `${BASE_URL}get/gamecategories`
export const POST_CATEGORY_API = `${BASE_URL}post/gamecategories`
export const DELETE_CATEGORY_API = (gamecategoryid) => `${BASE_URL}delete/gamecategories/${gamecategoryid}`;
export const PUT_CATEGORY_API = (gamecategoryid) => `${BASE_URL}update/gamecategories/${gamecategoryid}`;
export const GET_CATEGORY_BYID = (gamecategoryid) => `${BASE_URL}get/category/${gamecategoryid}`;

////////////group master//////////////////
export const GET_MASTER_API = `${BASE_URL}get/gamemasters`
export const POST_MASTER_API = `${BASE_URL}post/gamemasters`
export const DELETE_MASTER_API =(gamemasterid)=> `${BASE_URL}delete/gamemasters/${gamemasterid}`
export const PUT_MASTER_API = (gamemasterid) => `${BASE_URL}update/gamemasters/${gamemasterid}`;
export const GET_MASTER_BYID = (gamemasterid) => `${BASE_URL}get/master/${gamemasterid}`; 

/////////////card allocation//////////////
export const GET_ALLOCATION_API = `${BASE_URL}get/gamecardallocs`
export const POST_ALLOCATION_API = `${BASE_URL}post/gamecardallocs`
export const DELETE_ALLOCATION_API =(cardallocid)=> `${BASE_URL}delete/gamecardallocs/${cardallocid}`
export const PUT_ALLOCATION_API = (cardallocid) => `${BASE_URL}update/gamecardallocs/${cardallocid}`;
export const GET_ALLOCATION_BYID = (cardallocid) => `${BASE_URL}get/allocation/${cardallocid}`;
export const UPLOAD_ALLOCATION_API = `${BASE_URL}upload/gamecardallocs`;
export const FETCH_DATA_API = `${BASE_URL}get/fetchcategory`;
export const GET_GAME_CATEGORIES_API = `${BASE_URL}get/gamecategoriesforgame`;
export const GET_GAME_NAMES_API = `${BASE_URL}get/gamenames`;
export const GET_CARD_GROUPS_API = `${BASE_URL}get/cardgroups`;
export const GET_CARD_NAMES_API = `${BASE_URL}get/cardnames`;
export const GET_KARMIC_ANALYSIS = (gamename) => `${BASE_URL}get/karmicanalysis/${encodeURIComponent(gamename)}`;

//////////////Game PLay DB///////////////
export const GET_PLAY_API = `${BASE_URL}get/playdb`
export const POST_PLAY_API = `${BASE_URL}post/playdb`
export const DELETE_PLAY_API =(playid)=> `${BASE_URL}delete/playdb/${playid}`
export const PUT_PLAY_API = (playid) => `${BASE_URL}update/playdb/${playid}`;
export const GET_PLAY_BYID = (playid) => `${BASE_URL}get/play/${playid}`; 
export const GET_DECRYPTED_PLAY_API = `${BASE_URL}getdec/playdb`
export const GET_HISTORY_API= `${BASE_URL}get/history`;

///////////////Network////////////////
export const GET_NETWORK_API = `${BASE_URL}get/network`
export const POST_NETWORK_API = `${BASE_URL}post/network`
export const DELETE_NETWORK_API =(netid)=> `${BASE_URL}delete/network/${netid}`
export const PUT_NETWORK_API = (netid) => `${BASE_URL}update/network/${netid}`;
export const GET_NETWORK_BYID = (netid) => `${BASE_URL}get/network/${netid}`;

//////////chakra//////////////
export const GET_SPOKE_API = `${BASE_URL}get/spokes`
export const GET_BLADE_API = `${BASE_URL}get/blades`
export const GET_SPOKE_BYID = (spokeid) => `${BASE_URL}spokebyid/${spokeid}`;
export const GET_BLADE_BYID = (bladeid) => `${BASE_URL}bladebyid/${bladeid}`;
export const POST_SPOKE_API = `${BASE_URL}post/spokes`
export const POST_BLADE_API = `${BASE_URL}post/blades`
export const UPLOAD_CHAKRA_GAMES_API = `${BASE_URL}upload/chakragame`;
export const DELETE_SPOKE_API =(spokeid)=> `${BASE_URL}deletespoke/${spokeid}`
export const PUT_SPOKE_API = (spokeid) => `${BASE_URL}updatespoke/${spokeid}`;
export const DELETE_BLADE_API =(bladeid)=> `${BASE_URL}deleteblade/${bladeid}`
export const PUT_BLADE_API = (bladeid) => `${BASE_URL}updateblade/${bladeid}`;

//////////vajrachakra///////
export const GET_VAJRACHAKRA_API = `${BASE_URL}get/vajrachakra`;
export const POST_VAJRACHAKRA_API = `${BASE_URL}post/vajrachakra`
export const DELETE_VAJRACHAKRA_API =(vajraid)=> `${BASE_URL}delete/gamecardallocs/${vajraid}`
export const PUT_VAJRACHAKRA_API = (vajraid) => `${BASE_URL}update/gamecardallocs/${vajraid}`;

//////////chariot////////////
export const GET_GLOBAL_ETHICS_API = `${BASE_URL}get/globalethics`
export const GET_AI_CHARIOT_API = `${BASE_URL}get/aichariot`
export const GET_GLOBAL_ETHICS_BYID = (globalid) => `${BASE_URL}getbyid/${globalid}`;
export const GET_AI_CHARIOT_BYID = (chariotid) => `${BASE_URL}getbyid/${chariotid}`;
export const POST_GLOBAL_API = `${BASE_URL}post/global`
export const POST_AICHARIOT_API = `${BASE_URL}post/aichariot`
export const UPLOAD_CHARIOT_API = `${BASE_URL}upload/chariot`;
export const DELETE_AICHARIOT_API =(chariotid)=> `${BASE_URL}delete/${chariotid}`
export const PUT_AICHARIOT_API = (chariotid) => `${BASE_URL}update/${chariotid}`;
export const DELETE_GLOBAL_API =(globalid)=> `${BASE_URL}delete/${globalid}`
export const PUT_GLOBAL_API = (globalid) => `${BASE_URL}update/${globalid}`;
export const POST_PLAYEDCHARIOTGAME_API = `${BASE_URL}savechariotgamedata`

///////all game data submission////
export const SAVE_GAMEDATA = `${BASE_URL}savegamedata`
export const SAVE_KAABADATA_API = `${BASE_URL}savekaabadata`
export const SAVE_CROSSDATA_API = `${BASE_URL}savecrossdata`
export const SAVE_TAODATA_API = `${BASE_URL}savetaodata`
export const SAVE_ZORODATA_API = `${BASE_URL}savezorodata`
export const SAVE_SIKHDATA_API = `${BASE_URL}savesikhdata`
export const SAVE_TORAHDATA_API = `${BASE_URL}savetorahdata`
export const SAVE_AFRICANDATA_API = `${BASE_URL}saveafricandata`
export const SAVE_DATTADATA_API = `${BASE_URL}savedattadata`

//////////Cube Game/////////
export const GET_CUBEDATA_API = `${BASE_URL}get/cubedata`
export const UPLOAD_CUBEDATA_API = `${BASE_URL}upload/cubedata`;
export const POST_CUBE_API = `${BASE_URL}post/cubedata`
export const GET_CUBE_BYID = (cubeid) => `${BASE_URL}get/byid/${cubeid}`;
export const DELETE_CUBE_API =(cubeid)=> `${BASE_URL}delete/cube/${cubeid}`
export const PUT_CUBE_API = (cubeid) => `${BASE_URL}update/cube/${cubeid}`;
export const GET_ISLAM_API = `${BASE_URL}get/islam`;
export const GET_CHRISTIAN_API = `${BASE_URL}get/christian`;
export const GET_TAO_API = `${BASE_URL}get/yingyang`;
export const GET_ZORO_API = `${BASE_URL}get/zoro`;
export const GET_SIKH_API = `${BASE_URL}get/sikh`;
export const GET_TORAH_API = `${BASE_URL}get/torah`;
export const GET_AFRICAN_API = `${BASE_URL}get/african`;
export const GET_DATTA_API = `${BASE_URL}get/datta`;

// Added for openAPI key moved to .env of backend -- 4th Sept Sinam
export const RELIGION_OPENAI_API = `${BASE_URL}askbyreligion`;
export const OPENAI_API = `${BASE_URL}ask`;